var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.53516C17.5913 8.53516 19.1174 9.1673 20.2426 10.2925C21.3679 11.4177 22 12.9439 22 14.5352V21.5352H18V14.5352C18 14.0047 17.7893 13.496 17.4142 13.1209C17.0391 12.7459 16.5304 12.5352 16 12.5352C15.4696 12.5352 14.9609 12.7459 14.5858 13.1209C14.2107 13.496 14 14.0047 14 14.5352V21.5352H10V14.5352C10 12.9439 10.6321 11.4177 11.7574 10.2925C12.8826 9.1673 14.4087 8.53516 16 8.53516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.53516H2V21.5352H6V9.53516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.53516C5.10457 6.53516 6 5.63973 6 4.53516C6 3.43059 5.10457 2.53516 4 2.53516C2.89543 2.53516 2 3.43059 2 4.53516C2 5.63973 2.89543 6.53516 4 6.53516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1dd58b5ea9538d4cbd14a2be20180343.svg";
export { ForwardRef as ReactComponent };